import { Isvg } from './svg.interface';

const InfoSVG = ({ width = 14, height = 14, color = '#212B36' }: Isvg) => (
  <svg width={width} height={height} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      opacity="0.48"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.66667 0C2.98477 0 0 2.98477 0 6.66667C0 10.3486 2.98477 13.3333 6.66667 13.3333C10.3486 13.3333 13.3333 10.3486 13.3333 6.66667C13.3333 4.89856 12.631 3.20286 11.3807 1.95262C10.1305 0.702379 8.43478 0 6.66667 0ZM7.33333 9.33398C7.33333 9.70217 7.03486 10.0007 6.66667 10.0007C6.29848 10.0007 6 9.70217 6 9.33398V6.00065C6 5.63246 6.29848 5.33398 6.66667 5.33398C7.03486 5.33398 7.33333 5.63246 7.33333 6.00065V9.33398ZM6 4.00065C6 4.36884 6.29848 4.66732 6.66667 4.66732C7.03486 4.66732 7.33333 4.36884 7.33333 4.00065C7.33333 3.63246 7.03486 3.33398 6.66667 3.33398C6.29848 3.33398 6 3.63246 6 4.00065Z"
      fill="#C0C0C4"
    />
  </svg>
);

export default InfoSVG;
